import React, { useEffect } from 'react';
import { Box, Button, Collapse, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { useGetFolderByName } from '../hooks/useGetFolderByName';
const FolderUploadExists = props => {
    const { content, actions, folderName, parentFolder, onLoad, onError, onSelect } = props;
    const { data, isLoading, error, getFolder } = useGetFolderByName();
    const parentPath = parentFolder.path;
    useEffect(() => {
        onLoad === null || onLoad === void 0 ? void 0 : onLoad(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);
    useEffect(() => {
        if (folderName) {
            getFolder(folderName, parentPath);
        }
        else {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(undefined, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [folderName, parentPath, getFolder]);
    useEffect(() => {
        if (!error) {
            return;
        }
        // if no folder found, handle select
        if (error.statusCode === 404) {
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(undefined, false);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Collapse, { in: isLoading, style: { minHeight: 'unset' } },
            React.createElement(DialogContent, { style: { paddingTop: 8 } },
                React.createElement(DialogContentText, null, "Checking for existing folder..."))),
        React.createElement(Collapse, { in: !!data, style: { minHeight: 'unset' } },
            React.createElement(Box, { mx: 3, mt: 1 },
                React.createElement(Alert, { severity: 'warning' },
                    "Folder ",
                    React.createElement("strong", null, (data === null || data === void 0 ? void 0 : data.name) || '?'),
                    " already exists. Upload to existing folder or create a new folder."))),
        content,
        React.createElement(DialogActions, null,
            actions,
            React.createElement(Button, { color: 'primary', variant: 'outlined', disabled: isLoading, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(undefined, !!data) }, "Create New Folder"),
            React.createElement(Button, { color: 'primary', variant: 'contained', disabled: isLoading || !data, onClick: () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(data, true) }, "Upload to Existing"))));
};
export default FolderUploadExists;
//# sourceMappingURL=FolderUploadExists.js.map